import { notEmpty } from '@crehana/utils';
import { TransactionTypeEnum } from "../../../types/graphql/globals.gamification";
export function filterRewardTransaction(node) {
  return notEmpty(node) && node.transaction_type === TransactionTypeEnum.TYPE_EXCHANGED;
}